export default "__VITE_ASSET__cyPnOQrW__"